/**
 * Paths for build-time Markdown under `public/md/` (served as `/academy/md/...`).
 * Must stay in sync with `scripts/generate-md.ts` (Academy MD v3 layout under `public/md/`).
 */
export function safeSegment(seg: string): string {
  return seg.replace(/[/\\?%*:|"<>]/g, '-').replace(/\s+/g, '-') || 'unnamed';
}

export type MarkdownExportSpec =
  | { kind: 'course'; courseId: string }
  | { kind: 'lesson'; courseId: string; lessonId: string }
  | { kind: 'content'; contentId: string }
  | { kind: 'learning_path'; learningPath: string }
  | { kind: 'learning_path_course'; learningPath: string; courseId: string }
  | { kind: 'learning_path_lesson'; learningPath: string; courseId: string; lessonId: string }
  | { kind: 'learning_path_assessment'; learningPath: string };

/** Path relative to `public/md/` (no leading slash). */
export function markdownStoragePath(spec: MarkdownExportSpec): string {
  const s = safeSegment;
  switch (spec.kind) {
    case 'course':
      return `courses/${s(spec.courseId)}.md`;
    case 'lesson':
      return `courses/${s(spec.courseId)}/${s(spec.lessonId)}.md`;
    case 'content':
      return `content/${s(spec.contentId)}.md`;
    case 'learning_path':
      return `learning-paths/${s(spec.learningPath)}.md`;
    case 'learning_path_course':
      return `learning-paths/${s(spec.learningPath)}/${s(spec.courseId)}.md`;
    case 'learning_path_lesson':
      return `learning-paths/${s(spec.learningPath)}/${s(spec.courseId)}/${s(spec.lessonId)}.md`;
    case 'learning_path_assessment':
      return `learning-paths/${s(spec.learningPath)}/assessment.md`;
  }
}

/** Next.js href under basePath (leading slash, includes `/md/`). */
export function markdownHref(spec: MarkdownExportSpec): string {
  return `/md/${markdownStoragePath(spec)}`;
}
